import './instrument.js'
import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

function isGerman() {
  try {
    const lang = navigator.language || navigator.languages?.[0] || 'en';
    return lang.startsWith('de');
  } catch {
    return false;
  }
}

const FallbackComponent = () => {
  const de = isGerman();
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      backgroundColor: '#f9fafb',
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        padding: '32px',
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>&#9888;</div>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', marginBottom: '16px' }}>
          {de ? 'Ein Fehler ist aufgetreten' : 'Something went wrong'}
        </h2>
        <p style={{ color: '#6b7280', marginBottom: '24px' }}>
          {de ? 'Bitte laden Sie die Seite neu oder versuchen Sie es später erneut.' : 'Please reload the page or try again later.'}
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            width: '100%',
            padding: '12px 24px',
            backgroundColor: '#f43f5e',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          {de ? 'Seite neu laden' : 'Reload page'}
        </button>
      </div>
    </div>
  );
};

const NotFound = () => {
  const de = isGerman();
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      backgroundColor: '#f9fafb',
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        padding: '32px',
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>&#128279;</div>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', marginBottom: '16px' }}>
          {de ? 'Ungültiger Link' : 'Invalid Link'}
        </h2>
        <p style={{ color: '#6b7280' }}>
          {de
            ? 'Dieser Link ist nicht gültig. Bitte verwenden Sie den Link aus Ihrer E-Mail oder SMS.'
            : 'This link is not valid. Please use the link from your email or SMS.'}
        </p>
      </div>
    </div>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={FallbackComponent}>
      <BrowserRouter>
        <Routes>
          <Route path="/b/:token" element={<App />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
